import config from "../consts/config";
import utils from "./utils";

// http://docs.zhugeio.com/dev/js.html

let superProperty = {};

function initSuperProperty() {
  let platform = "网页";
  if (utils.isFoApp()) {
    platform = "App内嵌H5";
  }
  if (utils.isWeiXin()) {
    platform = "微信公众号";
  }
  superProperty = {
    //全局的事件属性(选填)
    应用名称: config.zhuge_app_id,
    平台: platform,
    platform: platform
  };
}

function init() {
  /*
       # 测试环境
       应用ID: 59
       App Key: e1fdd59a9a3341ee92b4ff13074643f0

       # 正式环境
       应用ID: 52
       App Key: 1963f16bf5854a4f96dbe30d734eae1a
  */
  initSuperProperty();

  window.zhuge.load(config.zhuge_app_key, {
    superProperty: superProperty,
    //启用全埋点采集（选填，默认false）
    autoTrack: true,
    singlePage: true //是否是单页面应用（SPA），启用autoTrack后生效（选填，默认false）
  });
}

function setIdentity(profile = {}) {
  console.log(`诸葛io: setIdentity`, profile);
  return new Promise((resolve, reject) => {
    const { id, nick_name, avatar_url, gender } = profile;
    if (!id) {
      return;
    }
    window.zhuge.identify(
      id,
      {
        ...superProperty,

        name: nick_name,
        //预定义属性
        avatar: avatar_url,
        gender: gender

        //预定义属性
        // 行业: "互联⽹网" //⾃自定义属性
      },
      resolve
    );
  });
}

function track(eventName, props = {}) {
  return new Promise((resolve, reject) => {
    const eventProps = {
      ...superProperty,
      ...props
    };
    window.zhuge.track(eventName, eventProps, resolve);
    console.log(`zhugeio-track:`, {
      eventName,
      eventProps
    });
  });
}

export default {
  init,
  setIdentity,
  track
};



// WEBPACK FOOTER //
// ./src/utils/zhugeio.js